import { SearchContent } from "./search-content.model";

export const SearchContentsValues: SearchContent[] = [
    {
        title: "Home - Upstream Data Foundation",
        keywords: "home, upstream, data, foundation, index",
        description:
            "A collection of cloud-based data technology, modern architecture, data applications, organizational capabilities, and data governance that will drive value for ExxonMobil...",
        url: "/",
    },
    {
        title: "Data Foundation",
        keywords:
            "upstream, data, foundation, udf, architecture, governance, landscape",
        description:
            "The Upstream Data Foundation (UDF) is both an aspirational architectural conceptual target for the unified, governed view of ExxonMobil's Upstream data as well as an organization in Upstream Digital responsible for stewarding the foundation's ongoing architectural and governance efforts...",
        url: "data-foundation",
    },
    {
        title: "Data Foundation - Data Governance",
        keywords:
            "data, governance, upstream, dama, dmbok, cdo, reuse, framework",
        description:
            "The Upstream Company is focused on delivering value, prioritizing the development of the highest quality resources, and executing with operational effectiveness...",
        url: "data-foundation-governance",
    },
    {
        title: "Data Foundation - Data Architecture & Modeling",
        keywords:
            "data, modeling, architecture, integration, enterprise, storage, policies, asssets, resources",
        description:
            "Data architecture describes the structure of physical data assets and data management resources, according to The Open Group Architecture Framework (TOGAF)...",
        url: "data-foundation-architecture",
    },
    {
        title: "Kepler Data Ingestion Request Form",
        keywords:
            "kepler, data, ingestion, request, form, support, contact, approval",
        description:
            "This form is to be used by Upstream customers when needing to import data into Kepler from one or multiple data sources...",
        url: "kepler-data-ingestion-request-form",
    },
    {
        title: "Frequently Asked Questions",
        keywords:
            "faq, frequently asked questions, ucdm, osdu, glossary, data model",
        description:
            " Q1. What does our Upstream Conceptual Data Model (UCDM) look like?  Whast does the Open Subsurface Data Universe (OSDU) data model look like?..",
        url: "data-foundation-faqs",
    },
    {
        title: "Platforms - Kepler",
        keywords:
            "platforms, data, kepler, energy, mission, upstream, discovery, future, growing, project, space, telescope, system, application, app, business",
        description:
            "Finding inspiration in the stars Named after famed astronomer Johannes Kepler, Nasa’s Kepler Space Telescope set out on a nine-year voyage to explore the structure and diversity of previously undiscovered planets...",
        url: "platforms-kepler",
    },
    {
        title: "Platforms - MDP",
        keywords: "mdp, platforms, datasets, business, analytics",
        description:
            "An integrated and modern data platform that centralize and exposes key unconventional datasets to end users, amplify business value, and enabling acceleration of critical decisions and insights through analytics...",
        url: "platforms-mdp",
    },
    {
        title: "Platforms  - UDA",
        keywords:
            "uda, upstream digital accelerator, platform, lakehouse, app, application,  analytics, data, business, data scientists",
        description:
            "The Upstream Digital Accelerator (UDA) Data Platform or The LakeHouse, is a system of reference developed and designed to join disparate data sources and provide simplified access to upstream data for Western Canadian Heavy Oil assets...",
        url: "platforms-uda",
    },
    {
        title: "Platforms - OSDU",
        keywords:
            "osdu, platform, app, application,  open group, cloud-agnostic, subsurface, environment, uddf, commercial data, interface",
        description:
            "An industry-wide initiative run by The Open Group to create a cloud-agnostic open subsurface environment. OSDU objectives are analogous to those of ExxonMobils...",
        url: "platforms-osdu",
    },
    {
        title: "University",
        keywords:
            "university, courses, course, training, learning, data producers, community, consumers, organization, lab, labs",
        description:
            "This University is always open for learning. There are several online classes and hands-on labs available to users and consumers of data...",
        url: "university",
    },
    {
        title: "University - Kepler",
        keywords:
            "university, kepler, self-paced, introduction, data engineers, data constructs, database concepts, objects, analysts, kepler platform, courses, course, training, learning, lab, labs",
        description:
            "This entry-level overview is designed for data engineers and data analysts as a basic introduction to the Kepler Platform...",
        url: "university-kepler",
    },
    {
        title: "University - Deeper Dive - Kepler",
        keywords:
            "university, kepler, advanced, data engineers, analysts, kepler platform, courses, course, training, learning, lab, labs",
        description:
            "This advanced course is designed for data engineers and data analysts as a deeper diver into the Kepler Platform...",
        url: "university-kepler-deeper",
    },
    {
        title: "University - Kepler for Data Analysts",
        keywords:
            "university, kepler, courses, kepler platform, insights, course, training, learning, lab, labs",
        description:
            "These courses prepare Data Analysts for work in Kepler reviewing data to help solve problems using data, learn critical insights about products and customers and boost profits...",
        url: "university-kepler-data-ana",
    },
    {
        title: "University - Kepler for Data Engineers",
        keywords:
            "university, kepler, courses, kepler platform, organizations, platform, course, training, learning, lab, labs",
        description:
            "The courses prepare Data Engineers to make data accessible so the organizations can use it to evaluate and optimize performance...",
        url: "university-kepler-data-eng",
    },
    {
        title: "University - MDP - Introduction",
        keywords:
            "university, mdp, mdp Platform, courses, course, entry-level, engineers, kql, operators, training, learning, lab, labs",
        description:
            "This entry-level overview is designed for data engineers and data analysts as a basic introduction to the MDP Platform...",
        url: "university-mdp",
    },
    {
        title: "University - UDA - Introduction",
        keywords:
            "university, uda, courses, course, data analysts, data engineers, uda, uda platform, data visualization, data analytics, training, learning, lab, labs",
        description:
            "This entry-level overview is designed for data engineers and data analysts as a basic introduction to the UDA Platform...",
        url: "university-uda",
    },
    {
        title: "University - Airflow Training",
        keywords:
            "university, courses, course, airflow, training, fundamental, pipeline, dag, modules, tasks, dependencies, time zones, learning, lab, labs",
        description:
            "This tutorial walks you through some of the fundamental Airflow concepts, objects, and their usage while writing your first pipeline...",
        url: "university-airflow-training",
    },
    {
        title: "University - Azure Data Explorer (ADX)",
        keywords:
            "university, courses, course, learning, lab, labs, azure, azure data explorer, big data, adx",
        description:
            "This course describes the ingestion, query, visualization, and data management features that Azure Data Explorer...",
        url: "azure-dataexplorer",
    },
    {
        title: "University - Kusto Query Language",
        keywords:
            "university, courses, course, learning, lab, labs, kql, kusto query language",
        description:
            "Get started by writing simple queries in Kusto Query Language (KQL) to explore and gain insights from your data...",
        url: "university-kusto",
    },
    {
        title: "University - Foundations of OpenShift",
        keywords:
            "university, courses, course, learning, lab, labs, red hat, openshift, servers, server, deploy, data-driven, app, application",
        description:
            "This course starts with the foundations to give you hands-on experience creating and deploying applications in Red Hat OpenShift...",
        url: "openshift-foundation",
    },
    {
        title: "University - Snowflake",
        keywords:
            "university, courses, course, learning, lab, labs, snowflake, sql, csv, json, tableau",
        description:
            "This entry-level guide designed for database and data warehouse administrators and architects will help you navigate the Snowflake...",
        url: "university-snowflake",
    },
    {
        title: 'University - Data Product - Thoughtworks Demos',
        keywords: 'university, courses, course, learning, lab, labs, thoughtworks, demo, pipeline',
        description: 'Thoughtworks performs a live demo of their data mesh platform on Azure in which they upskill and practice building data products...',
        url: 'data-products'
    },
    {
        title: "Success Stories",
        keywords:
            "success stories, success, global, well, png, iscout, kpa, gold, table",
        description: "List of success stories...",
        url: "success-stories",
    },
    {
        title: "Community of Practice",
        keywords: "community of practice, community, roles, responsabilities",
        description: "List of community practice...",
        url: "community-of-practice",
    },
    {
        title: "Community of Practice - UDF - Community of Practice",
        keywords:
            "community of practice, community, udf, upstream data foundation, literacy, cop",
        description:
            "The Upstream Data Foundation Community of Practice welcomes anyone interested in learning more about data ingestions, data platforms...",
        url: "UDF-CoP",
    },
    {
        title: "Community of Practice - What is Community of Practice",
        keywords:
            "community of practice, community, what is, jean lave, etienne wenger, learning, stories, cop",
        description:
            'In 1991, cognitive anthropologists Jean Lave and Etienne Wenger first coined the term "community of practice" while studying group learning...',
        url: "what-is-CoP",
    },
    {
        title: "Community of Practice - Benefits of Communities of Practice",
        keywords:
            "community of practice, community, cop, benefits, cops, organization, communities, collaboration, innovation",
        description:
            "Fostering and supporting communities of practice (CoPs) can be a great strategy for building a more open organization. Members of communities...",
        url: "benefits-CoP",
    },
    {
        title: "Community of Practice - Community of Practice Roles and Responsibilities",
        keywords:
            "community of practice, community, cop, roles, champion, community, membership, benefits",
        description:
            "There are three main roles required for a Community of Practice (CoP) to be successful. The roles, responsibilities, and time commitment are outlined below...",
        url: "CoP-Roles",
    },
    {
        title: "Community of Practice - CoP - Feedback",
        keywords:
            "community of practice, community, cop, roles, feedback, contact",
        description:
            "We welcome feedback on the UDF Website. Please let us know if there is additional content, training, or information you would like to see on the site...",
        url: "community-of-practice-feedback",
    },
];
